import { Text, Group } from '@mantine/core';
import BaseResult from '@/client/features/search/components/BaseResult';
import { type Tracker } from '@/constants/mercuryPages';
import { normalizeIpAddress } from '@/client/features/analyticsdashboard/services/addresses';
import List from '@/components/content/list/List';
import SourcesDrawer from '@/client/features/catalogs/features/sources/components/SourcesDrawer';
import Linkv2 from '@/components/content/link/Linkv2';

const IPAddressesSearchResults = ({ data }: { data: any }) => {
  const ipAddress = normalizeIpAddress(data);

  return (
    <BaseResult
      title={{ id: ipAddress.id, name: ipAddress.name }}
      customLink={<Linkv2>{ipAddress.name}</Linkv2>} // Clicking on the title shouldn't do anything (yet)
      content=""
      tracker={'temporary_tracker' as unknown as Tracker}
      footer={[
        <Text size="sm" key="type">
          <Text fw="bold" span>
            Address Type:
          </Text>{' '}
          {ipAddress.is_private ? 'Private' : 'Public'}
        </Text>,
        <Text size="sm" key="hostname">
          <Text fw="bold" span>
            Found Hostname:
          </Text>{' '}
          {ipAddress.hostname || 'None'}
        </Text>,
        <Text size="sm" key="datacenters">
          <Text fw="bold" span>
            Found in Datacenter IP Ranges:
          </Text>{' '}
          <Text span>
            {ipAddress.datacenters.length > 0 ? ipAddress.datacenters.join(', ') : 'None'}
          </Text>
        </Text>,
        <Text size="sm" key="vpns">
          <Text fw="bold" span>
            Found in VPN IP Ranges:
          </Text>{' '}
          <Text span>{ipAddress.vpns.length > 0 ? ipAddress.vpns.join(', ') : 'None'}</Text>
        </Text>,
        <Group gap={5} key="source" align="center">
          <Text fw="bold" size="sm" span>
            Source:
          </Text>
          <List
            gap={5}
            direction="row"
            align="center"
            items={ipAddress.catalog.source_ids.map((id: any, index: number) => ({
              id,
              name: ipAddress.catalog.source[index],
            }))}
            renderItem={(item: any) => <SourcesDrawer id={+item.id} name={item.name} />}
          />
        </Group>,
      ]}
    />
  );
};

export default IPAddressesSearchResults;
